<template>
  <div
    class="flex md:items-center justify-between md:flex-row flex-col mb-4.5 gap-5"
  >
    <div
      class="flex items-center gap-2"
      v-if="config.deleteButton?.active || config.addButton?.active"
    >
      <button
        type="button"
        class="btn btn-danger gap-2"
        v-if="config.deleteButton?.active"
        :disabled="deleteButtonDisabled"
        @click="deleteSelected"
      >
        <Icon type="svg" name="binOutline" />
        Delete
      </button>
      <router-link
        v-if="config.addButton?.active"
        :disabled="config.addButton?.disabled"
        :to="
          $i18nRoute({
            href: config.addButton?.route,
            name: config.addButton?.routeName,
          })
        "
        class="btn btn-primary gap-2"
        replace
      >
        <Icon type="svg" name="Add" />
        Add New
      </router-link>
    </div>
    <div class="flex items-center flex-wrap" v-if="config.downloads">
      <button
        type="button"
        class="btn btn-primary btn-sm m-1"
        @click="exportTable('csv')"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="w-5 h-5 ltr:mr-2 rtl:ml-2"
        >
          <path
            d="M15.3929 4.05365L14.8912 4.61112L15.3929 4.05365ZM19.3517 7.61654L18.85 8.17402L19.3517 7.61654ZM21.654 10.1541L20.9689 10.4592V10.4592L21.654 10.1541ZM3.17157 20.8284L3.7019 20.2981H3.7019L3.17157 20.8284ZM20.8284 20.8284L20.2981 20.2981L20.2981 20.2981L20.8284 20.8284ZM14 21.25H10V22.75H14V21.25ZM2.75 14V10H1.25V14H2.75ZM21.25 13.5629V14H22.75V13.5629H21.25ZM14.8912 4.61112L18.85 8.17402L19.8534 7.05907L15.8947 3.49618L14.8912 4.61112ZM22.75 13.5629C22.75 11.8745 22.7651 10.8055 22.3391 9.84897L20.9689 10.4592C21.2349 11.0565 21.25 11.742 21.25 13.5629H22.75ZM18.85 8.17402C20.2034 9.3921 20.7029 9.86199 20.9689 10.4592L22.3391 9.84897C21.9131 8.89241 21.1084 8.18853 19.8534 7.05907L18.85 8.17402ZM10.0298 2.75C11.6116 2.75 12.2085 2.76158 12.7405 2.96573L13.2779 1.5653C12.4261 1.23842 11.498 1.25 10.0298 1.25V2.75ZM15.8947 3.49618C14.8087 2.51878 14.1297 1.89214 13.2779 1.5653L12.7405 2.96573C13.2727 3.16993 13.7215 3.55836 14.8912 4.61112L15.8947 3.49618ZM10 21.25C8.09318 21.25 6.73851 21.2484 5.71085 21.1102C4.70476 20.975 4.12511 20.7213 3.7019 20.2981L2.64124 21.3588C3.38961 22.1071 4.33855 22.4392 5.51098 22.5969C6.66182 22.7516 8.13558 22.75 10 22.75V21.25ZM1.25 14C1.25 15.8644 1.24841 17.3382 1.40313 18.489C1.56076 19.6614 1.89288 20.6104 2.64124 21.3588L3.7019 20.2981C3.27869 19.8749 3.02502 19.2952 2.88976 18.2892C2.75159 17.2615 2.75 15.9068 2.75 14H1.25ZM14 22.75C15.8644 22.75 17.3382 22.7516 18.489 22.5969C19.6614 22.4392 20.6104 22.1071 21.3588 21.3588L20.2981 20.2981C19.8749 20.7213 19.2952 20.975 18.2892 21.1102C17.2615 21.2484 15.9068 21.25 14 21.25V22.75ZM21.25 14C21.25 15.9068 21.2484 17.2615 21.1102 18.2892C20.975 19.2952 20.7213 19.8749 20.2981 20.2981L21.3588 21.3588C22.1071 20.6104 22.4392 19.6614 22.5969 18.489C22.7516 17.3382 22.75 15.8644 22.75 14H21.25ZM2.75 10C2.75 8.09318 2.75159 6.73851 2.88976 5.71085C3.02502 4.70476 3.27869 4.12511 3.7019 3.7019L2.64124 2.64124C1.89288 3.38961 1.56076 4.33855 1.40313 5.51098C1.24841 6.66182 1.25 8.13558 1.25 10H2.75ZM10.0298 1.25C8.15538 1.25 6.67442 1.24842 5.51887 1.40307C4.34232 1.56054 3.39019 1.8923 2.64124 2.64124L3.7019 3.7019C4.12453 3.27928 4.70596 3.02525 5.71785 2.88982C6.75075 2.75158 8.11311 2.75 10.0298 2.75V1.25Z"
            fill="currentColor"
          />
          <path
            opacity="0.5"
            d="M13 2.5V5C13 7.35702 13 8.53553 13.7322 9.26777C14.4645 10 15.643 10 18 10H22"
            stroke="currentColor"
            stroke-width="1.5"
          />
        </svg>
        CSV
      </button>
      <button
        type="button"
        class="btn btn-primary btn-sm m-1"
        @click="exportTable('txt')"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="w-5 h-5 ltr:mr-2 rtl:ml-2"
        >
          <path
            d="M15.3929 4.05365L14.8912 4.61112L15.3929 4.05365ZM19.3517 7.61654L18.85 8.17402L19.3517 7.61654ZM21.654 10.1541L20.9689 10.4592V10.4592L21.654 10.1541ZM3.17157 20.8284L3.7019 20.2981H3.7019L3.17157 20.8284ZM20.8284 20.8284L20.2981 20.2981L20.2981 20.2981L20.8284 20.8284ZM14 21.25H10V22.75H14V21.25ZM2.75 14V10H1.25V14H2.75ZM21.25 13.5629V14H22.75V13.5629H21.25ZM14.8912 4.61112L18.85 8.17402L19.8534 7.05907L15.8947 3.49618L14.8912 4.61112ZM22.75 13.5629C22.75 11.8745 22.7651 10.8055 22.3391 9.84897L20.9689 10.4592C21.2349 11.0565 21.25 11.742 21.25 13.5629H22.75ZM18.85 8.17402C20.2034 9.3921 20.7029 9.86199 20.9689 10.4592L22.3391 9.84897C21.9131 8.89241 21.1084 8.18853 19.8534 7.05907L18.85 8.17402ZM10.0298 2.75C11.6116 2.75 12.2085 2.76158 12.7405 2.96573L13.2779 1.5653C12.4261 1.23842 11.498 1.25 10.0298 1.25V2.75ZM15.8947 3.49618C14.8087 2.51878 14.1297 1.89214 13.2779 1.5653L12.7405 2.96573C13.2727 3.16993 13.7215 3.55836 14.8912 4.61112L15.8947 3.49618ZM10 21.25C8.09318 21.25 6.73851 21.2484 5.71085 21.1102C4.70476 20.975 4.12511 20.7213 3.7019 20.2981L2.64124 21.3588C3.38961 22.1071 4.33855 22.4392 5.51098 22.5969C6.66182 22.7516 8.13558 22.75 10 22.75V21.25ZM1.25 14C1.25 15.8644 1.24841 17.3382 1.40313 18.489C1.56076 19.6614 1.89288 20.6104 2.64124 21.3588L3.7019 20.2981C3.27869 19.8749 3.02502 19.2952 2.88976 18.2892C2.75159 17.2615 2.75 15.9068 2.75 14H1.25ZM14 22.75C15.8644 22.75 17.3382 22.7516 18.489 22.5969C19.6614 22.4392 20.6104 22.1071 21.3588 21.3588L20.2981 20.2981C19.8749 20.7213 19.2952 20.975 18.2892 21.1102C17.2615 21.2484 15.9068 21.25 14 21.25V22.75ZM21.25 14C21.25 15.9068 21.2484 17.2615 21.1102 18.2892C20.975 19.2952 20.7213 19.8749 20.2981 20.2981L21.3588 21.3588C22.1071 20.6104 22.4392 19.6614 22.5969 18.489C22.7516 17.3382 22.75 15.8644 22.75 14H21.25ZM2.75 10C2.75 8.09318 2.75159 6.73851 2.88976 5.71085C3.02502 4.70476 3.27869 4.12511 3.7019 3.7019L2.64124 2.64124C1.89288 3.38961 1.56076 4.33855 1.40313 5.51098C1.24841 6.66182 1.25 8.13558 1.25 10H2.75ZM10.0298 1.25C8.15538 1.25 6.67442 1.24842 5.51887 1.40307C4.34232 1.56054 3.39019 1.8923 2.64124 2.64124L3.7019 3.7019C4.12453 3.27928 4.70596 3.02525 5.71785 2.88982C6.75075 2.75158 8.11311 2.75 10.0298 2.75V1.25Z"
            fill="currentColor"
          />
          <path
            opacity="0.5"
            d="M6 14.5H14"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            opacity="0.5"
            d="M6 18H11.5"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            opacity="0.5"
            d="M13 2.5V5C13 7.35702 13 8.53553 13.7322 9.26777C14.4645 10 15.643 10 18 10H22"
            stroke="currentColor"
            stroke-width="1.5"
          />
        </svg>
        TXT
      </button>
      <vue3-json-excel
        class="btn btn-primary btn-sm m-1 cursor-pointer"
        name="table.xls"
        :fields="excelColumns()"
        :json-data="excelItems()"
        worksheet="Sheet1"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="w-5 h-5 ltr:mr-2 rtl:ml-2"
        >
          <path
            d="M15.3929 4.05365L14.8912 4.61112L15.3929 4.05365ZM19.3517 7.61654L18.85 8.17402L19.3517 7.61654ZM21.654 10.1541L20.9689 10.4592V10.4592L21.654 10.1541ZM3.17157 20.8284L3.7019 20.2981H3.7019L3.17157 20.8284ZM20.8284 20.8284L20.2981 20.2981L20.2981 20.2981L20.8284 20.8284ZM14 21.25H10V22.75H14V21.25ZM2.75 14V10H1.25V14H2.75ZM21.25 13.5629V14H22.75V13.5629H21.25ZM14.8912 4.61112L18.85 8.17402L19.8534 7.05907L15.8947 3.49618L14.8912 4.61112ZM22.75 13.5629C22.75 11.8745 22.7651 10.8055 22.3391 9.84897L20.9689 10.4592C21.2349 11.0565 21.25 11.742 21.25 13.5629H22.75ZM18.85 8.17402C20.2034 9.3921 20.7029 9.86199 20.9689 10.4592L22.3391 9.84897C21.9131 8.89241 21.1084 8.18853 19.8534 7.05907L18.85 8.17402ZM10.0298 2.75C11.6116 2.75 12.2085 2.76158 12.7405 2.96573L13.2779 1.5653C12.4261 1.23842 11.498 1.25 10.0298 1.25V2.75ZM15.8947 3.49618C14.8087 2.51878 14.1297 1.89214 13.2779 1.5653L12.7405 2.96573C13.2727 3.16993 13.7215 3.55836 14.8912 4.61112L15.8947 3.49618ZM10 21.25C8.09318 21.25 6.73851 21.2484 5.71085 21.1102C4.70476 20.975 4.12511 20.7213 3.7019 20.2981L2.64124 21.3588C3.38961 22.1071 4.33855 22.4392 5.51098 22.5969C6.66182 22.7516 8.13558 22.75 10 22.75V21.25ZM1.25 14C1.25 15.8644 1.24841 17.3382 1.40313 18.489C1.56076 19.6614 1.89288 20.6104 2.64124 21.3588L3.7019 20.2981C3.27869 19.8749 3.02502 19.2952 2.88976 18.2892C2.75159 17.2615 2.75 15.9068 2.75 14H1.25ZM14 22.75C15.8644 22.75 17.3382 22.7516 18.489 22.5969C19.6614 22.4392 20.6104 22.1071 21.3588 21.3588L20.2981 20.2981C19.8749 20.7213 19.2952 20.975 18.2892 21.1102C17.2615 21.2484 15.9068 21.25 14 21.25V22.75ZM21.25 14C21.25 15.9068 21.2484 17.2615 21.1102 18.2892C20.975 19.2952 20.7213 19.8749 20.2981 20.2981L21.3588 21.3588C22.1071 20.6104 22.4392 19.6614 22.5969 18.489C22.7516 17.3382 22.75 15.8644 22.75 14H21.25ZM2.75 10C2.75 8.09318 2.75159 6.73851 2.88976 5.71085C3.02502 4.70476 3.27869 4.12511 3.7019 3.7019L2.64124 2.64124C1.89288 3.38961 1.56076 4.33855 1.40313 5.51098C1.24841 6.66182 1.25 8.13558 1.25 10H2.75ZM10.0298 1.25C8.15538 1.25 6.67442 1.24842 5.51887 1.40307C4.34232 1.56054 3.39019 1.8923 2.64124 2.64124L3.7019 3.7019C4.12453 3.27928 4.70596 3.02525 5.71785 2.88982C6.75075 2.75158 8.11311 2.75 10.0298 2.75V1.25Z"
            fill="currentColor"
          />
          <path
            opacity="0.5"
            d="M13 2.5V5C13 7.35702 13 8.53553 13.7322 9.26777C14.4645 10 15.643 10 18 10H22"
            stroke="currentColor"
            stroke-width="1.5"
          />
          <path
            opacity="0.5"
            d="M7 14L6 15L7 16M11.5 16L12.5 17L11.5 18M10 14L8.5 18"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        XLS
      </vue3-json-excel>
      <button
        type="button"
        class="btn btn-primary btn-sm m-1"
        @click="exportTable('print')"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="w-5 h-5 ltr:mr-2 rtl:ml-2"
        >
          <path
            d="M6 17.9827C4.44655 17.9359 3.51998 17.7626 2.87868 17.1213C2 16.2426 2 14.8284 2 12C2 9.17157 2 7.75736 2.87868 6.87868C3.75736 6 5.17157 6 8 6H16C18.8284 6 20.2426 6 21.1213 6.87868C22 7.75736 22 9.17157 22 12C22 14.8284 22 16.2426 21.1213 17.1213C20.48 17.7626 19.5535 17.9359 18 17.9827"
            stroke="currentColor"
            stroke-width="1.5"
          />
          <path
            opacity="0.5"
            d="M9 10H6"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M19 14L5 14"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            d="M18 14V16C18 18.8284 18 20.2426 17.1213 21.1213C16.2426 22 14.8284 22 12 22C9.17157 22 7.75736 22 6.87868 21.1213C6 20.2426 6 18.8284 6 16V14"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            opacity="0.5"
            d="M17.9827 6C17.9359 4.44655 17.7626 3.51998 17.1213 2.87868C16.2427 2 14.8284 2 12 2C9.17158 2 7.75737 2 6.87869 2.87868C6.23739 3.51998 6.06414 4.44655 6.01733 6"
            stroke="currentColor"
            stroke-width="1.5"
          />
          <circle opacity="0.5" cx="17" cy="10" r="1" fill="currentColor" />
          <path
            opacity="0.5"
            d="M15 16.5H9"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
          <path
            opacity="0.5"
            d="M13 19H9"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
        PRINT
      </button>
    </div>
    <div class="flex items-center flex-wrap" v-else></div>
    <div class="dropdown" v-if="config.customCols">
      <Popper
        :placement="rtlClass === 'rtl' ? 'bottom-end' : 'bottom-start'"
        offsetDistance="0"
        class="align-middle"
      >
        <button
          type="button"
          class="flex items-center border font-semibold border-[#e0e6ed] dark:border-[#253b5c] rounded-md px-4 py-2 text-sm dark:bg-[#1b2e4b] dark:text-white-dark"
        >
          <span class="ltr:mr-1 rtl:ml-1">Columns</span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-5 h-5"
          >
            <path
              d="M19 9L12 15L5 9"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <template #content>
          <ul class="whitespace-nowrap">
            <template v-for="(col, i) in innerCols" :key="i">
              <li>
                <div class="flex items-center px-4 py-1">
                  <label class="cursor-pointer mb-0">
                    <input
                      type="checkbox"
                      class="form-checkbox"
                      :id="`chk-${i}`"
                      :value="col.field"
                      @change="toggleCol(i, $event)"
                      :checked="!col.hide"
                    />
                    <span :for="`chk-${i}`" class="ltr:ml-2 rtl:mr-2">{{
                      col.title
                    }}</span>
                  </label>
                </div>
              </li>
            </template>
          </ul>
        </template>
      </Popper>
    </div>
    <div class="text-right" v-if="config.search">
      <input
        v-model="innerSearch"
        type="text"
        class="form-input w-auto"
        placeholder="Search..."
      />
    </div>
  </div>
</template>

<script>
import { computed, reactive, ref } from "vue";
import store from "@/store";
export default {
  props: {
    searchString: {
      type: String,
      default: "",
    },
    cols: { type: Array, default: () => [] },
    rows: { type: Array, default: () => [] },
    config: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, ctx) {
    const emit = ctx.emit;
    const innerSearch = computed({
      get() {
        return props.searchString;
      },
      set(value) {
        emit("update:searchString", value);
      },
    });
    const innerCols = computed({
      get() {
        return props.cols;
      },
      set(value) {
        emit("update:cols", value);
      },
    });

    const toggleCol = (i, e) => {
      innerCols.value.forEach((el, idx) => {
        if (i == idx) el.hide = !e.target.checked;
      });
      emit("update:cols", innerCols.value);
    };
    const rtlClass = computed(() => store.getters.getRtlClass);
    const excelItems = () => {
      return props.rows;
    };
    const excelColumns = () => {
      return innerCols.value;
    };

    const title = computed(() => document.title.split(" | ")[0]);
    const exportTable = (type) => {
      let columns = innerCols.value.map((d) => {
        return d.field;
      });

      let records = props.rows;
      let filename = title;

      let newVariable;
      newVariable = window.navigator;

      if (type == "csv") {
        let coldelimiter = ";";
        let linedelimiter = "\n";
        let result = columns
          .map((d) => {
            return capitalize(d);
          })
          .join(coldelimiter);
        result += linedelimiter;
        records.map((item) => {
          columns.map((d, index) => {
            if (index > 0) {
              result += coldelimiter;
            }
            let val = item[d] ? item[d] : "";
            result += val;
          });
          result += linedelimiter;
        });

        if (result == null) return;
        if (
          !result.match(/^data:text\/csv/i) &&
          !newVariable.msSaveOrOpenBlob
        ) {
          var data =
            "data:application/csv;charset=utf-8," + encodeURIComponent(result);
          var link = document.createElement("a");
          link.setAttribute("href", data);
          link.setAttribute("download", filename.value + ".csv");
          link.click();
        } else {
          var blob = new Blob([result]);
          if (newVariable.msSaveOrOpenBlob) {
            newVariable.msSaveBlob(blob, filename.value + ".csv");
          }
        }
      } else if (type == "print") {
        var rowhtml = "<p>" + filename.value + "</p>";
        rowhtml +=
          '<table style="width: 100%; " cellpadding="0" cellcpacing="0"><thead><tr style="color: #515365; background: #eff5ff; -webkit-print-color-adjust: exact; print-color-adjust: exact; "> ';
        columns.map((d) => {
          rowhtml += "<th>" + capitalize(d) + "</th>";
        });
        rowhtml += "</tr></thead>";
        rowhtml += "<tbody>";

        records.map((item) => {
          rowhtml += "<tr>";
          columns.map((d) => {
            let val = item[d] ? item[d] : "";
            rowhtml += "<td>" + val + "</td>";
          });
          rowhtml += "</tr>";
        });
        rowhtml +=
          "<style>body {font-family:Arial; color:#495057;}p{text-align:center;font-size:18px;font-weight:bold;margin:15px;}table{ border-collapse: collapse; border-spacing: 0; }th,td{font-size:12px;text-align:left;padding: 4px;}th{padding:8px 4px;}tr:nth-child(2n-1){background:#f7f7f7; }</style>";
        rowhtml += "</tbody></table>";
        var winPrint = window.open(
          "",
          "",
          "left=0,top=0,width=1000,height=600,toolbar=0,scrollbars=0,status=0"
        );
        winPrint.document.write("<title>Print</title>" + rowhtml);
        winPrint.document.close();
        winPrint.focus();
        winPrint.print();
        // winPrint.close();
      } else if (type == "txt") {
        let coldelimiter = ",";
        let linedelimiter = "\n";
        let result = columns
          .map((d) => {
            return capitalize(d);
          })
          .join(coldelimiter);
        result += linedelimiter;
        records.map((item) => {
          columns.map((d, index) => {
            if (index > 0) {
              result += coldelimiter;
            }
            let val = item[d] ? item[d] : "";
            result += val;
          });
          result += linedelimiter;
        });

        if (result == null) return;
        if (
          !result.match(/^data:text\/txt/i) &&
          !newVariable.msSaveOrOpenBlob
        ) {
          var data =
            "data:application/txt;charset=utf-8," + encodeURIComponent(result);
          var link = document.createElement("a");
          link.setAttribute("href", data);
          link.setAttribute("download", filename.value + ".txt");
          link.click();
        } else {
          var blob = new Blob([result]);
          if (newVariable.msSaveOrOpenBlob) {
            newVariable.msSaveBlob(blob, filename.value + ".txt");
          }
        }
      }
    };
    const capitalize = (text) => {
      return text
        .replace("_", " ")
        .replace("-", " ")
        .toLowerCase()
        .split(" ")
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(" ");
    };
    const deleteSelected = (e) => {
      ctx.emit("deleteSelected", e);
    };

    const deleteButtonDisabled = ref(props.config.deleteButton?.disabled);

    return {
      innerSearch,
      innerCols,
      deleteButtonDisabled,
      rtlClass,
      excelItems,
      excelColumns,
      exportTable,
      deleteSelected,
      toggleCol,
      title,
    };
  },
};
</script>

<style>
</style>